import React from 'react';
import { StyledSvgIcon } from '../icon.styles';
import { customIconsPropTypes } from './customicons.propTypes';

const CondoIcon = ({ fontSize, color, sx, title }) => (
  <StyledSvgIcon
    fontSize={fontSize}
    color={color}
    titleAccess={title}
    data-testid={title}
    aria-label={title}
    sx={sx}
  >
    <svg
      width="30"
      height="33"
      viewBox="0 0 30 33"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1 32H29M2.27273 1H27.7273M3.54545 1V32M26.4545 1V32M9.90909 7.45833H12.4545M9.90909 12.625H12.4545M9.90909 17.7917H12.4545M17.5455 7.45833H20.0909M17.5455 12.625H20.0909M17.5455 17.7917H20.0909M9.90909 32V26.1875C9.90909 25.118 10.7644 24.25 11.8182 24.25H18.1818C19.2356 24.25 20.0909 25.118 20.0909 26.1875V32"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  </StyledSvgIcon>
);
export default CondoIcon;

CondoIcon.propTypes = customIconsPropTypes;
